/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Not_Found_MessageInputs */

const en_common_not_found_message = /** @type {(inputs: Common_Not_Found_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page not found`)
};

const zh_common_not_found_message = /** @type {(inputs: Common_Not_Found_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面不存在`)
};

/**
* | output |
* | --- |
* | "Page not found" |
*
* @param {Common_Not_Found_MessageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_not_found_message = /** @type {((inputs?: Common_Not_Found_MessageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Not_Found_MessageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_not_found_message(inputs)
	return zh_common_not_found_message(inputs)
});
export { common_not_found_message as "common.not_found.message" }